import { formatCurrency } from 'utils';

import { AccountConstraint } from '../_openapi/portfolio-optimizer';

export interface AccountConstraintField {
    label: string;
    value: string;
    isCapped: boolean;
}

/**
 * What the account constraint row shows, shared by the CIP and HUB views: the sell mandate (capped on a withdrawal run)
 * and the cash budget. HUB only shows the daily rebalance, so its mandate is never capped.
 */
export const toAccountConstraintFields = (accountConstraint?: AccountConstraint | null): AccountConstraintField[] =>
    accountConstraint
        ? [
              {
                  label: 'Sell mandate',
                  value: formatCurrency(accountConstraint.minSellConstraint),
                  isCapped: accountConstraint.isCappedAtMinSell ?? false,
              },
              { label: 'Cash budget', value: formatCurrency(accountConstraint.maxBuyConstraint), isCapped: false },
          ]
        : [];
